import { Helmet } from "react-helmet";
import { CheckoutComponentChatAttibutesType } from "../../types/builder";

const ManyChat: React.FC<
  Pick<CheckoutComponentChatAttibutesType, "accountId">
> = ({ accountId }) => {
  return (
    <Helmet>
      <script src={`//widget.manychat.com/${accountId}.js`} defer></script>
      <script src="https://mccdn.me/assets/js/widget.js" defer></script>
    </Helmet>
  );
};

export default ManyChat;
